var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
export default Vue.extend({
    name: 'leftMenu',
    computed: __assign({}, mapState('user', {
        activeMenu: 'activeMenu',
        leftMenuList: 'leftMenuList',
        featureList: 'featureList',
        activeIndex: 'activeIndex',
    }), { user: function () {
            return this.$store.state.user;
        } }),
    data: function () {
        return {};
    },
    methods: {
        oneMenu: function (key) {
            this.$omega.trackEvent('dasf_kzt_menuclick', {
                name: key,
                position: 'left',
            });
            this.user.openMenu = key;
        },
        handleOpen: function (key) {
            this.sendOmega(key);
            this.user.openMenu = key;
        },
        handleClose: function (key) {
            this.sendOmega(key);
            this.user.openMenu = [];
        },
        changeURL: function (url) {
            var newUrl = url.split(':')[1];
            return "https:" + newUrl;
        },
        sendOmega: function (key) {
            this.$omega.trackEvent('dasf_kzt_menuclick', {
                name: key,
                position: 'left',
            });
        },
        toggleIcon: function (index, item, type) {
            if (type === 'over') {
                this.activeIndex[index] = true;
            }
            else {
                this.activeIndex[index] = false;
            }
        },
    },
    watch: {
        activeIndex: function () {
            return this.activeIndex;
        },
        leftMenuList: {
            deep: true,
            handler: function (val) {
                var path = this.$route.path;
                var list = val;
                var len = list.length;
                var activeMenu = '';
                var openMenu = '';
                var featureList = this.featureList;
                var feature = featureList.find(function (f) { return f.url === path; });
                if (!val && len === 0) {
                    return this.$router.push({ path: '/' });
                }
                if (feature) {
                    activeMenu = feature.resourceCode;
                    var fea = featureList.find(function (f) { return f.resourceCode === feature.resourceCode; });
                    if (fea) {
                        openMenu = fea.parentCode;
                    }
                    this.$store.commit('user/update', {
                        activeMenu: activeMenu,
                        openMenu: openMenu,
                    });
                }
            },
        },
    },
});
